/**
 * Composant pour afficher les informations spécifiques aux tuiles.
 *
 * Le badge de score Kamaé (icône ceinture + « X pts ») a été retiré de
 * l'affichage des tuiles : il n'apparaissait qu'en breakpoint xs (vue étroite)
 * et n'est plus souhaité. Le composant ne rend donc plus rien aujourd'hui, mais
 * est conservé comme point d'extension pour de futures infos par tuile.
 */
const TileSpecificInfo = () => {
  return null;
};

export default TileSpecificInfo;
